import { createSlice } from "@reduxjs/toolkit"

export const studentSlice = createSlice({
  name: "studentSlice",
  initialState: {
    studentList: [],
    exportList: [],
    detail: {},
    totalEntry: 0, 
    isFreshData: false,
  },  
  reducers: {
    setStudentList: (state, action) => {
      state.studentList = action.payload
    },
    setFreshList: (state, action) => {
      state.isFreshData = action.payload
  },
    setExportList: (state, action) => {
      state.exportList = action.payload
    },
    setTotalEntry: (state, action) => {
      state.totalEntry = action.payload
    },
    setSingleData: (state, action) => {
      state.detail = action.payload
    }

  }
})

export const {
  setStudentList,
  setFreshList,
  setExportList,
  setSingleData,
  setTotalEntry,
  setFilteredList
} = studentSlice.actions

export const selectStudentList = (state) => state.student.studentList
export const selectFreshList = (state) => state.student.isFreshData
export const selectExportList = (state) => state.student.exportList
export const selectTotalEntry = (state) => state.student.totalEntry
export const selectSingleDetail = (state) => state.student.detail

export default studentSlice.reducer
